const styles = () => ({
  page: {
    backgroundColor: '#F3F6F6',
  },
});

export default styles;
